module.exports = __webpack_public_path__ + "static/media/melted.453be369.jpeg";